import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./Subscription.module.sass";
import Icon from "../Icon";
import useNewsletter from "../../hooks/useNewsletter";

const Subscription = ({ className, placeholder }) => {
  const [email, setEmail] = useState("");
  const { 
    isLoading, 
    error, 
    success, 
    message, 
    subscribe, 
    validateEmail, 
    resetState 
  } = useNewsletter();

  // Réinitialiser l'état quand l'email change
  useEffect(() => {
    if (error || success) {
      const timer = setTimeout(() => {
        resetState();
      }, 5000); // Effacer le message après 5 secondes

      return () => clearTimeout(timer);
    }
  }, [error, success, resetState]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email.trim()) {
      return;
    }

    if (!validateEmail(email)) {
      return;
    }

    await subscribe(email);
    
    // Vider le champ email en cas de succès
    if (!error) {
      setEmail("");
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    // Réinitialiser les messages d'erreur quand l'utilisateur tape
    if (error || success) {
      resetState();
    }
  };

  return (
    <div className={cn(styles.container, className)}>
      <form
        className={cn(styles.form, {
          [styles.loading]: isLoading,
          [styles.error]: error,
          [styles.success]: success
        })}
        onSubmit={handleSubmit}
      >
        <input
          className={styles.input}
          type="email"
          value={email}
          onChange={handleEmailChange}
          name="email"
          placeholder={placeholder}
          required
          disabled={isLoading}
        />
        <button 
          className={styles.btn} 
          type="submit"
          disabled={isLoading || !email.trim()}
        >
          {isLoading ? (
            <Icon name="loader" size="14" />
          ) : (
            <Icon name="arrow-right" size="14" />
          )}
        </button>
      </form>
      
      {/* Messages de feedback */}
      {(error || success || message) && (
        <div className={cn(styles.feedback, {
          [styles.feedbackError]: error,
          [styles.feedbackSuccess]: success
        })}>
          {error || message}
        </div>
      )}
    </div>
  );
};

export default Subscription;
